import {
  BOOKING_FORM_SELECTOR,
  SINGLE_SELECT_INITIALISED_ATTRIBUTE,
} from "./singleSelects/constants";
import bindDropdownEvents from "./singleSelects/bindDropdownEvents";
import buildDropdownButton from "./singleSelects/buildDropdownButton";
import buildDropdownMenu from "./singleSelects/buildDropdownMenu";
import syncSelectedLabel from "./singleSelects/syncSelectedLabel";

const initialiseSingleSelects = () => {
  const bookingForms = document.querySelectorAll<HTMLFormElement>(
    BOOKING_FORM_SELECTOR
  );

  bookingForms.forEach((bookingForm) => {
    const singleSelects = findSingleSelects(bookingForm);

    singleSelects.forEach((singleSelect) => {
      initialiseSingleSelect(singleSelect);
    });
  });
};

const findSingleSelects = (bookingForm: HTMLFormElement) => {
  return Array.from(
    bookingForm.querySelectorAll<HTMLSelectElement>("select")
  ).filter(
    (selectElement) =>
      !selectElement.multiple &&
      !isMultiSelectSource(selectElement) &&
      selectElement.dataset[SINGLE_SELECT_INITIALISED_ATTRIBUTE] !== "true"
  );
};

const initialiseSingleSelect = (selectElement: HTMLSelectElement) => {
  selectElement.dataset[SINGLE_SELECT_INITIALISED_ATTRIBUTE] = "true";

  const wrapperElement = document.createElement("div");
  wrapperElement.className = "relative mt-1";

  const dropdownButton = buildDropdownButton(selectElement);
  const dropdownMenu = buildDropdownMenu(selectElement, dropdownButton);

  selectElement.insertAdjacentElement("beforebegin", wrapperElement);
  wrapperElement.append(selectElement, dropdownButton, dropdownMenu);

  selectElement.classList.add("sr-only");
  syncSelectedLabel(selectElement, dropdownButton);

  bindDropdownEvents({
    selectElement,
    dropdownButton,
    dropdownMenu,
    wrapperElement,
  });
};

const isMultiSelectSource = (selectElement: HTMLSelectElement) => {
  return selectElement.dataset.multiSelectInit === "true";
};

export { findSingleSelects, initialiseSingleSelect };
export default initialiseSingleSelects;
